module.exports = __webpack_public_path__ + "img/bonus_symbol_3.ba92f572.png";